<template>
  <div class="w-full">
    <vx-card class="my-5">
      <global-user
        :src="
          user.avatar ||
          'https://pixinvent.com/demo/vuesax-vuexy-vuejs-admin-dashboard-template/demo-1/img/avatar-s-6.0c96c10d.jpg'
        "
        :name="user.name"
        :subname="`${user.location} ( ${user.position} )`"
      ></global-user>
      <div class="w-full flex mt-5">
        <div class="w-full md:w-1/3 px-3 mb-4">
          <div class="mb-2">Bulan</div>
          <vs-select :options="filters.bulan" v-model="month"></vs-select>
        </div>
        <div class="w-full md:w-1/3 px-3 mb-4">
          <div class="mb-2">Tahun</div>
          <vs-select :options="filters.tahun" v-model="year"></vs-select>
        </div>
      </div>
    </vx-card>

    <global-table>
      <template #thead>
        <global-th left="0" class="sticky-col">No.</global-th>
        <global-th>Tanggal</global-th>
        <global-th>Status</global-th>
        <global-th>Waktu Mulai</global-th>
        <global-th>Waktu Selesai</global-th>
        <global-th></global-th>
      </template>
      <template #tbody>
        <global-tr v-for="(report, index) in reports" :key="index">
          <global-td>{{ index + 1 }}</global-td>
          <global-td>{{ report.tanggal | indonesian_date }}</global-td>
          <global-td>
            <vs-chip color="success">{{
              report.keterangan == "Hadir" ? "Hadir Di Kantor" : "WFH"
            }}</vs-chip>
            <div v-if="report.tipe">
              <vs-chip
                v-if="report.tipe.clock_in && report.tipe.clock_in == 'late'"
                color="danger"
                >Telat Memulai</vs-chip
              >
              <vs-chip
                v-if="
                  report.tipe.clock_in &&
                  report.tipe.clock_out == 'early_clock_out'
                "
                color="danger"
                >Mendahului Selesai</vs-chip
              >
            </div>
          </global-td>
          <global-td>{{ report.jam_mulai }}</global-td>
          <global-td>{{ report.jam_selesai }}</global-td>
          <global-td
            ><vs-button
              size="small"
              @click="clickedShow(report.uuid)"
              icon-pack="feather"
              icon="icon-eye"
              >Detail</vs-button
            ></global-td
          >
        </global-tr>
      </template>
    </global-table>

    <vs-button @click="$router.go(-1)" type="border">Kembali</vs-button>
  </div>
</template>

<script>
import VsSelect from "vue-select";
import { digofHttp } from "@/axios";

export default {
  components: {
    VsSelect,
  },
  data() {
    return {
      filters: {
        bulan: [
          {
            label: "Januari",
            value: 1,
          },
          {
            label: "Februari",
            value: 2,
          },
          {
            label: "Maret",
            value: 3,
          },
          {
            label: "April",
            value: 4,
          },
          {
            label: "Mei",
            value: 5,
          },
          {
            label: "Juni",
            value: 6,
          },
          {
            label: "Juli",
            value: 7,
          },
          {
            label: "Agustus",
            value: 8,
          },
          {
            label: "September",
            value: 9,
          },
          {
            label: "Oktober",
            value: 10,
          },
          {
            label: "November",
            value: 11,
          },
          {
            label: "Desember",
            value: 12,
          },
        ],
        tahun: [
          {
            label: 2020,
            value: 2020,
          },
          {
            label: 2021,
            value: 2021,
          },
        ],
      },
      reports: [],
      user: {
        name: "",
        avatar: "",
        position: "",
        location: "",
      },
      month: {
        label: "",
        value: "",
      },
      year: {
        label: "",
        value: "",
      },
    };
  },
  methods: {
    clickedShow(uuid) {
      this.$router.push({
        name: "laporan-absensi-pegawai-detail",
        params: { uuid: this.$route.params.uuid, uuidAbsensi: uuid },
      });
    },
    loadReport() {
      this.$vs.loading();
      digofHttp
        .get(
          `/attendance/report/${this.$route.params.uuid}?month=${this.month.value}&year=${this.year.value}`
        )
        .then((r) => {
          this.reports = r.data.data.reports;
          this.user = r.data.data.user;
        })
        .catch((e) => {
          alert(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  mounted() {
    this.loadReport();
  },
  watch: {
    month() {
      this.loadReport();
    },
    year() {
      this.loadReport();
    },
  },
};
</script>
